import { render, staticRenderFns } from "./updater.vue?vue&type=template&id=9a584872&"
import script from "./updater.vue?vue&type=script&lang=js&"
export * from "./updater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports